import React, { Fragment } from 'react';

const FeatureList = ({ featureList }) => (
    <Fragment>
        {featureList && featureList.length > 0 && <ul className="feature-list">
            {featureList.map((item, index) => {
                return item.iconHtml != null && item.iconHtml != undefined ? <li key={index} className={item.text != undefined && item.text.value ? "has-info" : ""}>
                    {item.iconHtml && <div className="feature-list__icon" dangerouslySetInnerHTML={{ __html: item.iconHtml }}></div>}
                    <div className="feature-list__title">{item.title}</div>
                    {item.text != undefined && item.text.value && <div className="feature-list__info-details">
                        <div className="feature-list__info-details-title">{item.title != undefined ? item.title : ""}</div>
                        <div dangerouslySetInnerHTML={{ __html: (item.text != undefined ? item.text.value : "") }}></div>
                    </div>}
                </li> : 
                <li key={index} className={item.Text != undefined && item.Text.Value ? "has-info" : ""}>
                {item.IconHtml && <div className="feature-list__icon" dangerouslySetInnerHTML={{ __html: item.IconHtml }}></div>}
                <div className="feature-list__title">{item.Title}</div>
                {item.Text != undefined && item.Text.Value && <div className="feature-list__info-details">
                    <div className="feature-list__info-details-title">{item.Title != undefined ? item.Title : ""}</div>
                    <div dangerouslySetInnerHTML={{ __html: (item.Text != undefined ? item.Text.Value : "") }}></div>
                </div>}
            </li>
            })}
        </ul>
        }
    </Fragment>
)

export default FeatureList;